import { ObservableArray, View } from "binder"
import { MachineEditorViewModel, Serial } from "./machineEditor-viewModel"
import { MachineModelSelectorViewModel } from "../machineModelSelector-viewModel";

export class MachineEditorView extends View<MachineEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-76EC9613-86E9-4A35-8AEB-E5C4484912EF"
    }
    loadHtml(): string {
        let element = require('./machineEditor.html').default;
        let style = require('./machineEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set serialId(v: string) { this._serialId = v; } public get serialId(): string { return this._serialId; } private _serialId: string;
    public set machineModelId(v: string) { this._machineModelId = v; } public get machineModelId(): string { return this._machineModelId; } private _machineModelId: string;
    public set machineModelSelector(v: MachineModelSelectorViewModel) { this._machineModelSelector = v; } public get machineModelSelector(): MachineModelSelectorViewModel { return this._machineModelSelector; } private _machineModelSelector: MachineModelSelectorViewModel;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;
    public set serials(v: ObservableArray<Serial>) { this._serials = v; } public get serials(): ObservableArray<Serial> { return this._serials; } private _serials: ObservableArray<Serial>;
    public set isCreate(v: boolean) { this._isCreate = v; } public get isCreate(): boolean { return this._isCreate; } private _isCreate: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }

    addNewSerial() {
        this.dataContext.addNewSerial();
    }
}
